/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

    export class HttpErrorMessages {
        
        public static readonly Http403 = "You are unauthorised to access this area. Please try logging out and logging back in again.";
        public static readonly Http404 = "The link is broken or the page has been moved.";
        public static readonly HttpError = "There was a problem serving the requested page. Usually this means that an unexpected error happened while processing your request.";

}